const search = new URLSearchParams(location.search)

export const isSinglePlayerMode = () => {
  return search.get('sp') === 'true'
}
